import { useContext } from "react"
import { DataContext } from "../contexts/DataContext"

export const useData = () => {
   const values = useContext(DataContext)
   return values
}